import React, { Component } from 'react';
import { size, isEmpty } from "lodash";
import { ListLayout } from '../containers/Layout';

import { TableRow, TableCell, Button, Grid, TableHead, TableBody, IconButton } from '@material-ui/core';
import { AddRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';

class ListResaItem extends Component {
    state = { }

    componentDidMount = () => {
        console.log("MOUNTING ListResaItems ");
    }

    createResaList = (list) => {
        const { RESAS, SHOPS, CLIENTS, PRODUCTS, rowsPerPage, currentPageProd } = this.props

        return list.slice(currentPageProd * rowsPerPage, currentPageProd * rowsPerPage + rowsPerPage).map(resaItem => {

            let client = CLIENTS[resaItem.sale_item_client_id]
            let shop = SHOPS[resaItem.sale_item_shop]
            let product = PRODUCTS[resaItem.product_id]
            let resa = RESAS[resaItem.sale_id]
            return (
                <TableRow key={resaItem.id} >
                    <TableCell>{(new Date(resaItem.sale_item_date)).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>{product.name} - {product.marque}</TableCell>
                    <TableCell>{resaItem.quantity}</TableCell>
                    <TableCell>
                        {shop ? (
                            <a 
                                href="#" 
                                onClick={ () => this.props.handleSingleShop(shop) }
                            > 
                                {shop.name}
                            </a>
                        ) : (
                            <span>{resaItem.sale_item_shop}</span>
                        )}
                    </TableCell>
                    <TableCell>
                        <IconButton 
                            color="secondary"
                            onClick={
                                () => this.props.handleSingleResa(resa, shop, client)
                            }
                        >
                            <AddRounded />
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })        
    }  
    
    filterAll = () => {
        const { searchProduct } = this.props;

        let newList = this.props.getFilteredList()

        let itemList = []
        newList.forEach(resa => 
            itemList.push(...resa.products)
        )
        if( !isEmpty(searchProduct)){
            itemList = itemList.filter(item => this.props.prodFilter(item.product_id))
        }
        return itemList
    }

    displayList = () => {
        const { RESAS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(RESAS)){
            let filteredList = this.filterAll()
            rows = size(filteredList)
            tab = this.createResaList(filteredList)
        }
        return [tab, rows]
    }

    render() {
        let resaList = this.displayList()

        return (
            <div>
                <ListLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            <TableCell>Shop</TableCell>
                            <TableCell>Détails</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { resaList[1] !== 0  && 
                            resaList[0]
                        }
                        { resaList[1] === 0  && 
                        <TableCell>
                            <TableCell colSpan={7}>
                                <div className="text-center">
                                    <h5>Pas encore de Réservations</h5> 
                                    Cliquez sur <b className="onglet">"Nouveau"</b> Pour créer un nouvelle Réservation
                                </div>
                            </TableCell>
                        </TableCell>
                        }
                    </TableBody>
                    { resaList[1] > 20  && 
                        <TableFooterPagination 
                            colSpan={5}
                            // items={resaList[0]} 
                            count={resaList[1]}
                            onChangePage={this.props.onChangePage}
                            initialPage={this.props.currentPageProd || 0}
                            page={this.props.currentPageProd}
                        />         
                    }                              
                </ListLayout>
            </div>
        );
    }
}


export default ListResaItem;